import { Box, ColorOptions, IconOptions, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { FC, memo, useState } from 'react'
import { TooltipView } from '../../../../../../src/comps/TootTipView'
import { TextInputWithDelete } from '../../../../../comps/TextInputWithDelete'
import { Colors, pages, tooltipConfig } from '../../../../../util/util'
import { FileModeTextInput, PassKeyTextInput } from '../InfoDropDown'
import { styles } from '../ReportingStyles'
import { passwordPlaceholder } from '../helper'

export const SFTPFileTransferModeComponent: FC = memo(
  ({
    setFieldValue,
    fieldName,
    allValues,
    label,
    editable,
    sUpdate,
    isNewPassword,
    setIsNewPassword,
    ...prop
  }: any) => {
    const [passwordError, setPasswordError] = useState('')
    const [sNewPassword, setNewPassword] = useState(isNewPassword?.email)

    const updateSFTPConfig = (value: any, key: any) => {
      const currentFiled = Object.assign({}, allValues[fieldName])
      currentFiled[key] = value

      //setFiledObject((prev: any) => ({ ...prev, [fieldName]: currentFiled }))
      validateTheFieldValue(value, key)
      setFieldValue(fieldName, currentFiled)
    }

    const regexPass = /^[a-zA-Z0-9]{8,40}$/
    const validateTheFieldValue = (value: any, key: any): boolean => {
      let isValid = false
      if (key === 'sftpConfigPassKey') {
        setNewPassword(true)

        if (value === passwordPlaceholder) {
          setIsNewPassword?.('sftp', false)
        } else {
          setIsNewPassword?.('sftp', true)
        }
        if (sUpdate && !sNewPassword) {
          //console.log('old pass ')
          return true
        } else if (value?.length > 0 && value !== passwordPlaceholder) {
          //console.log('new pass ', regexPass)
          if (!regexPass.test(value)) {
            setPasswordError(
              'Password invalid, Password must contain 8 alpha-numeric characters. Special characters are not allowed.',
            )
            return false
          } else {
            setPasswordError('')
            return false
          }
        } else {
          setPasswordError('')
        }
      }
      return isValid
    }

    return (
      <Box {...styles.mainView}>
        <SpacerNew size={15} direction={'vertical'} />

        <SpacerNew size={30} direction={'vertical'} />
        <Box {...styles.textAndIcon}>
          <Box {...styles.titleAligner}>
            <TextNew title={label} {...styles.titleText} />
          </Box>
          <Box>
            <TooltipView
              iconColor={'#202F4D8A' as ColorOptions}
              fontSize={12}
              value={tooltipConfig.sftpConfigInfo}
              top={-35}
              alignLeft={true}
              iconSize={14}
            />
          </Box>
        </Box>
        <SpacerNew size={5} direction={'vertical'} />

        <Box {...styles.configurationContainer}>
          <SpacerNew size={15} direction={'vertical'} />

          <TextInputWithDelete
            fieldName={fieldName}
            label={prop?.config.recipients ?? pages.create_config.email_recipients}
            placeholder={prop?.config.recipients ?? pages.create_config.email_recipients}
            editable={editable}
            //setFieldValue={setFieldValue}
            setFieldValue={(val: any) => updateSFTPConfig(val, 'sftpNotifyRecipients')}
            value={allValues[fieldName]?.sftpNotifyRecipients}
            title={prop?.config.recipients ?? pages.create_config.email_recipients}
            isEmail={true}
            touched={true}
            badgeWidth={250}
            gridHeight={60}
            error="Please enter Email ID followed by comma , or space"
            testID="email_recipients"
            allValues={allValues}
            color={'#528BFF' as ColorOptions}
            borderColor={'#B9CBF0' as ColorOptions}
            titleColor={'#202F4D8A' as ColorOptions}
            setValuesOnFieldNameObject={true}
            fieldNameObjectKey={'sftpNotifyRecipients'}
            bgColor={Colors.DISABLED_PRIMARY as ColorOptions}
            valuesBorderColor={'TRANSPARENT'}
            fontFamily={'jiotype-medium'}
            borderRadius={4}
            showToolTipInfo={true}
            toolTipInfoComponent={
              <TooltipView
                iconColor={'#202F4D8A' as ColorOptions}
                fontSize={12}
                value={tooltipConfig.sftpConfigRecipentsInfo}
                top={-65}
                alignLeft={true}
                iconSize={14}
              />
            }
          />

          <SpacerNew size={15} direction={'vertical'} />
          <FileModeTextInput
            onChangeText={(val: string) => updateSFTPConfig(val, 'sftpConfigSubjLine')}
            //value={fieldObject.emailSubject}
            value={allValues[fieldName]?.sftpConfigSubjLine}
            fieldName={fieldName}
            allValues={allValues}
            editable={editable}
            title={pages.create_config.subject_line}
            placeHolder={pages.create_config.subject_line_placeholder}
            width={'100%'}
            secureTextEntry={false}
            tooltipInfo={tooltipConfig.sftpConfigSubjInfo}
            maxLength={150}
            isOptional={true}
            insertDateTime={true}
            top={-50}
          />

          <SpacerNew size={15} direction={'vertical'} />
          <ModBox flexDirection={'row'}>
            <Box f={1} flexDirection="row" flex={1}>
              <FileModeTextInput
                onChangeText={(val: string) => updateSFTPConfig(val, 'sftpConfigFileName')}
                //value={fieldObject.emailFile}
                value={allValues[fieldName]?.sftpConfigFileName}
                fieldName={fieldName}
                allValues={allValues}
                editable={editable}
                title={pages.create_config.filename}
                placeHolder={pages.create_config.filename_placeholder}
                secureTextEntry={false}
                rightIcon={'LOCK' as IconOptions}
                rightOnPress={() => console.log('icon pressed')}
                tooltipInfo={tooltipConfig.sftpConfigFileNameInfo}
                maxLength={25}
                isOptional={true}
                top={-20}
                insertDateTime={true}
                autoComplete={'new-password'}
              />

              <Spacer size={20} direction={'horizontal'} />

              <PassKeyTextInput
                onChangeText={(val: string) => updateSFTPConfig(val, 'sftpConfigPassKey')}
                //value={fieldObject.emailFilePassKey}
                value={allValues[fieldName]?.sftpConfigPassKey}
                fieldName={fieldName}
                allValues={allValues}
                editable={editable}
                title={pages.create_config.passkey}
                placeHolder={pages.create_config.passkey_placeholder}
                secureTextEntry={true}
                rightAction={'Reset'}
                rightOnPress={() => updateSFTPConfig('', 'sftpConfigPassKey')}
                error={passwordError}
                tooltipInfo={tooltipConfig.sftpConfigPassKeyInfo}
                maxLength={40}
                top={-20}
                sUpdate={sUpdate}
                autoComplete={'new-password'}
              />
            </Box>
          </ModBox>

          <SpacerNew size={15} direction={'vertical'} />
        </Box>
      </Box>
    )
  },
)
